<template>
  <div class="row">
    <SwappingSquaresSpinner v-if="modalLoader"
      :animation-duration="1000"
      :size="90"
      :color="this.$store.getters.config.palette.primary"
      style="margin: 30px auto;"
    />
    <div v-if="!modalLoader" class="flex xs12">
      <vue-web-cam
        ref="webcam"
        :device-id="deviceId"
        @started="onStarted"
        @stopped="onStopped"
        @error="onError"
        @cameras="onCameras"
        @camera-change="onCameraChange"
      />
      <select v-model="camera">
        <option>-- {{ $t('scanner.selectDevice') }} --</option>
        <option
          v-for="device in devices"
          :key="device.deviceId"
          :value="device.deviceId"
        >{{ device.label }}</option>
      </select>

      <va-button icon="fa fa-camera" @click.prevent="onCapture"> {{ $t('scanner.capture') }}</va-button>
    </div>
  </div>
</template>

<script>
import { WebCam } from 'vue-web-cam'
import { SwappingSquaresSpinner } from 'epic-spinners'

export default {
  name: 'Alpr',
  components: {
    'vue-web-cam': WebCam,
    SwappingSquaresSpinner,
  },
  data () {
    return {
      isCameraShow: false,
      camera: null,
      deviceId: null,
      devices: [],
      modalLoader: false,
    }
  },
  props: {
    clientId: Number,
  },
  methods: {
    onStarted (stream) {
    },
    onStopped (stream) {
    },
    // eslint-disable-next-line handle-callback-err
    onError (error) {
    },
    onCameras (cameras) {
      this.devices = cameras
    },
    onCameraChange (deviceId) {
      this.deviceId = deviceId
      this.camera = deviceId
    },
    readFileAsync (file) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader()
        reader.onload = () => {
          resolve(reader.result)
        }
        reader.onerror = reject
        reader.readAsDataURL(file)
      })
    },
    onCapture () {
      const capturedImage = this.$refs.webcam.capture()
      this.qrLoading = true
      const isFalse = true
      if (isFalse) {
        this.modalLoader = true
        this.$store.dispatch('carDetection', {
          clientId: this.clientId,
          upload: {
            data: capturedImage,
            type: 'image/jpeg',
          },
        }).then((resp) => this.initClient(resp.data.message))
      }
    },
    async initClient (client) {
      this.modalLoader = false
      this.$emit('theClient', client)
    },
    detectClientInfo () {
      this.isCameraShow = true
      setInterval(() => {
        // this.$refs.webcam.start()
      }, 1000)
    },
    async processFile () {
      const video = this.$refs.detectionAlpr.$refs.input.files[0]
      // eslint-disable-next-line no-unused-vars
      const arrayBuffer = await this.readFileAsync(video)

      if (arrayBuffer === null) {
        return
      }
      this.isSelectedFile = true
      this.uploadRequest = {
        data: arrayBuffer,
        duration: 0,
        type: video.type,
        size: video.size,
        title: video.name,
        clientIdentifier: '',
      }
    },
  },
  watch: {
    camera: function (id) {
      this.deviceId = id
    },
    devices: function () {
      // Once we have a list select the first one
      // eslint-disable-next-line no-unused-vars
      const [first, ...tail] = this.devices
      if (first) {
        this.camera = first.deviceId
        this.deviceId = first.deviceId
      }
    },
  },
}
</script>

<style scoped>

</style>
